import DataTable from "app/components/DataTable";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { SuperModelRow } from "../../types";
import { useStyles } from "./styles";

type Props = {
  rows: SuperModelRow[];
  loading?: boolean;
};

const renderValue = (
  value: string | number | null | undefined,
  styles: ReturnType<typeof useStyles>
) => (
  <span className={styles.textCell}>
    {value === null || value === undefined || value === "" ? "-" : value}
  </span>
);

const SuperModelTable = ({ rows, loading = false }: Props) => {
  const { t } = useTranslation();
  const styles = useStyles();

  const columns = useMemo(
    () => [
      {
        id: "superModelName",
        label: t("SUPER_MODEL.TABLE.NAME"),
        align: "right",
        width: "33.33%",
        format: (row: SuperModelRow) =>
          renderValue(row.superModelName, styles),
      },
      {
        id: "manufacturerName",
        label: t("SUPER_MODEL.TABLE.MANUFACTURER"),
        align: "right",
        width: "33.33%",
        format: (row: SuperModelRow) =>
          renderValue(row.manufacturerName, styles),
      },
      {
        id: "priority",
        label: t("SUPER_MODEL.TABLE.PRIORITY"),
        align: "right",
        width: "33.33%",
        format: (row: SuperModelRow) => renderValue(row.priority, styles),
      },
    ],
    [styles, t]
  );

  return (
    <div className={styles.root} dir="rtl">
      <DataTable
        rows={rows}
        columns={columns}
        loading={loading && rows.length === 0}
        serialEnabled={false}
        noDataLabel={t("SUPER_MODEL.EMPTY")}
      />
    </div>
  );
};

export default SuperModelTable;
